// removed by extract-text-webpack-plugin
module.exports = {"pausedBarContainer":"style__pausedBarContainer__1jipJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account_page/account_info/paused_bar/style.scss
// module id = 1046
// module chunks = 0